export function loadWhatsappBusinessSignUp() {
  const dataContainer = $('#whatsapp-business-sign-up');
  const appId = dataContainer.data('app-id');
  const configurationId = dataContainer.data('configuration-id');
  const signupUrl = dataContainer.data('signup-url');

  let wbaId = null; // WhatsApp Business Account ID
  let waEmbeddedSignupCode = null; // Temporary access token from Embedded Signup
  let sent = false;

  const postSignupCallback = () => {
    if (wbaId && waEmbeddedSignupCode && !sent) {
      sent = true;
      $.ajax({
        url: signupUrl,
        type: 'POST',
        data: { external_id: wbaId, signup_code: waEmbeddedSignupCode },
        error: () => {
          sent = false;
        },
      });
    }
  };

  /* eslint-disable */
  window.fbAsyncInit = () => {
    // JavaScript SDK configuration and setup
    FB.init({
      appId,
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v22.0',
    });
  };

  // Session logging message event listener
  window.addEventListener('message', (event) => {
    if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP' && data.event === 'FINISH') {
        wbaId = data.data?.waba_id;
        postSignupCallback();
      }
    } catch {
      console.log('message event: ', event.data);
    }
  });

  // Response callback
  const fbLoginCallback = (response) => {
    if (response.authResponse) {
      waEmbeddedSignupCode = response.authResponse.code;
      postSignupCallback();
    }
  }

  // Launch method and callback registration
  const launchWhatsAppSignup = () => {
    wbaId = null;
    waEmbeddedSignupCode = null;
    sent = false;

    FB.login(fbLoginCallback, {
      config_id: configurationId,
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: '',
        sessionInfoVersion: '3',
      }
    });
  }

  // Load the JavaScript SDK asynchronously
  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

  $('#whatsapp-business-sign-up').on('click', (e) => {
    e.preventDefault();
    launchWhatsAppSignup();
  });
  /* eslint-enable */
}

export function verificationFlowActions(whatsappBusinessAccountId) {
  $(document).on('click', `a.verification-setup-${whatsappBusinessAccountId}:not(.close-ds-modal)`, (e) => {
    e.preventDefault();
    $(`.verification-setup-${whatsappBusinessAccountId}`).addClass('is-hidden');
    $(`.verification-method-${whatsappBusinessAccountId}`).removeClass('is-hidden');
  });
}
